<script>
import {
  LogAdDeepLinkClicked,
  LogCompanyHomepageLinkClicked,
  LogCompanyAddressClicked,
  LogPhoneNumberClick,
  LogPhoneNumberShown,
  LogCriteoConfirmation,
  LogAccordionContactClicked,
} from '@/events'

// get id from url
const locationSplit = window.location.pathname.split('/'),
  id = locationSplit[locationSplit.length - 1]

export default {
  template: '<template></template>',
  props: {
    type: { default: '', type: String },
    companyId: { default: '', type: String },
  },
  mounted() {
    const containers = document.getElementsByClassName('js-contact-container')

    Array.from(containers).forEach(container => {
      this.handleDeeplink(container)
      this.handleHomepageLink(container)
      this.handleContactAddress(container)
      this.handlePhoneNumberShown(container)
      this.handlePhoneNumberClick(container)
      this.handleContactEmailClicked(container)
    })
  },
  methods: {
    handleContactEmailClicked(container) {
      this.handleLink(container, 'js-contact-email', () => {
        LogAccordionContactClicked(this.type)
      })
    },
    handlePhoneNumberShown(container) {
      this.handleLink(
        container,
        'js-contact-show-phone',
        () => {
          LogPhoneNumberShown(this.type, id)
          LogCriteoConfirmation(+id)
        },
        'change'
      )
    },
    handlePhoneNumberClick(container) {
      let loggingHasBeenDone = false
      this.handleLink(container, 'js-contact-click-phone', event => {
        if (!loggingHasBeenDone) {
          event.preventDefault()

          LogPhoneNumberClick(this.type, id).then(() => {
            loggingHasBeenDone = true

            event.target.click()
          })
        }
      })
    },
    handleContactAddress(container) {
      if (this.companyId === '0') return

      this.handleLink(container, 'js-contact-address', () => {
        LogCompanyAddressClicked(this.companyId)
      })
    },
    handleDeeplink(container) {
      this.handleLink(container, 'js-contact-deeplink', () => {
        LogAdDeepLinkClicked(id)
        LogCriteoConfirmation(+id)
      })
    },
    handleHomepageLink(container) {
      if (this.companyId === '0') return

      this.handleLink(container, 'js-contact-homepage-link', () => {
        LogCompanyHomepageLinkClicked(this.companyId)
        LogCriteoConfirmation(+id)
      })
    },
    handleLink(container, className, callback, eventName = 'click') {
      const links = container.getElementsByClassName(className)

      Array.from(links).forEach(link => {
        link.addEventListener(eventName, event => {
          callback(event)
        })
      })
    },
  },
}
</script>
